import React from "react";
import "./TryProductSection.scss";

interface HeroSectionProps {
  heading?: string;
  subheading?: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  heading = "Trusted by 2,500+ corporates and travel agencies",
  subheading = "No more chasing emails or customer support. Simply search, download, and stay organized.",
  buttonText = "Get Started",
  onButtonClick = () => console.log("Button clicked"),
}) => {
  return (
    <div className="TryProduct-section">
      <div className="TryProduct-content">
        <h1 className="TryProduct-heading">{heading}</h1>
        <p className="TryProduct-subheading">{subheading}</p>
        <button className="TryProduct-button" onClick={onButtonClick}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default HeroSection;
